module.exports = __webpack_public_path__ + "static/media/mkv.15112342.svg";